import React, { useState } from "react";
import axios from "axios";
import "./AdminPanel.css";

function AdminPanel() {
  const [formData, setFormData] = useState({
    title: "",
    nights: "",
    days: "",
    locations: "",
    shortDescription: "",
  });

  const [coverImage, setCoverImage] = useState(null);
  const [images, setImages] = useState([]);
  const [daysPlan, setDaysPlan] = useState([]);

  const [day, setDay] = useState({
    dayNumber: 1,
    title: "",
    description: "",
    overnightStay: "",
    meals: "",
    activities: [],
  });

  const [activity, setActivity] = useState({
    timeOfDay: "",
    activity: "",
    notes: "",
    images: [],
  });

  // Add activity inside the current day
  const addActivity = () => {
    setDay({
      ...day,
      activities: [...day.activities, { ...activity }],
    });
    setActivity({ timeOfDay: "", activity: "", notes: "", images: [] });
  };

  // Add a complete day plan
  const addDay = () => {
    setDaysPlan([
      ...daysPlan,
      { ...day, meals: day.meals.split(",").map((m) => m.trim()) },
    ]);
    setDay({
      dayNumber: day.dayNumber + 1,
      title: "",
      description: "",
      overnightStay: "",
      meals: "",
      activities: [],
    });
  };

  // Submit final itinerary
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("title", formData.title);
    data.append(
      "duration",
      JSON.stringify({ nights: formData.nights, days: formData.days })
    );
    data.append("locations", JSON.stringify(formData.locations.split(",")));
    data.append("shortDescription", formData.shortDescription);

    if (coverImage) data.append("coverImage", coverImage);
    images.forEach((img) => data.append("images", img));

    data.append("daysPlan", JSON.stringify(daysPlan));

    try {
      await axios.post("https://ttfadmin.onrender.com/api/itineraries", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("Itinerary created successfully!");
      setFormData({
        title: "",
        nights: "",
        days: "",
        locations: "",
        shortDescription: "",
      });
      setCoverImage(null);
      setImages([]);
      setDaysPlan([]);
    } catch (err) {
      console.error(err);
      alert("Error creating itinerary");
    }
  };

  return (
    <div className="admin-panel">
      <header className="admin-header">
        <h2>Create New Itinerary</h2>
        <p className="muted">Create and manage trip itineraries. Fields marked * are required.</p>
      </header>

      <div className="admin-body">
        <form className="itinerary-form" onSubmit={handleSubmit}>
          <section className="form-row">
            <div className="form-group">
              <label>Trip Title *</label>
              <input
                type="text"
                placeholder="Trip Title"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                required
              />
            </div>

            <div className="form-group">
              <label>Duration</label>
              <div className="inline-fields">
                <input
                  type="number"
                  placeholder="Nights"
                  value={formData.nights}
                  onChange={(e) => setFormData({ ...formData, nights: e.target.value })}
                />
                <input
                  type="number"
                  placeholder="Days"
                  value={formData.days}
                  onChange={(e) => setFormData({ ...formData, days: e.target.value })}
                />
              </div>
            </div>
          </section>

          <section className="form-row">
            <div className="form-group">
              <label>Locations</label>
              <input
                type="text"
                placeholder="Locations (comma separated)"
                value={formData.locations}
                onChange={(e) => setFormData({ ...formData, locations: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Short Description</label>
              <textarea
                placeholder="Short Description"
                value={formData.shortDescription}
                onChange={(e) => setFormData({ ...formData, shortDescription: e.target.value })}
              />
            </div>
          </section>

          <section className="form-row">
            <div className="form-group">
              <label>Cover Image</label>
              <input type="file" onChange={(e) => setCoverImage(e.target.files[0])} />
            </div>

            <div className="form-group">
              <label>Extra Images</label>
              <input type="file" multiple onChange={(e) => setImages(Array.from(e.target.files))} />
            </div>
          </section>

          <section className="day-builder">
            <h3>Day {day.dayNumber} Plan</h3>
            <div className="form-row">
              <div className="form-group">
                <label>Day Title</label>
                <input type="text" placeholder="Day Title" value={day.title} onChange={(e) => setDay({ ...day, title: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Overnight Stay</label>
                <input type="text" placeholder="Overnight Stay" value={day.overnightStay} onChange={(e) => setDay({ ...day, overnightStay: e.target.value })} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group full">
                <label>Day Description</label>
                <textarea placeholder="Day Description" value={day.description} onChange={(e) => setDay({ ...day, description: e.target.value })} />
              </div>
            </div>

            <div className="activities">
              <h4>Add Activity</h4>
              <div className="form-row">
                <input type="text" placeholder="Time of Day" value={activity.timeOfDay} onChange={(e) => setActivity({ ...activity, timeOfDay: e.target.value })} />
                <input type="text" placeholder="Activity" value={activity.activity} onChange={(e) => setActivity({ ...activity, activity: e.target.value })} />
                <input type="text" placeholder="Notes" value={activity.notes} onChange={(e) => setActivity({ ...activity, notes: e.target.value })} />
                <button type="button" className="btn-secondary" onClick={addActivity}>+ Add Activity</button>
              </div>

              <div className="activities-preview">
                {day.activities.map((a, i) => (
                  <div key={i} className="activity-item">
                    <strong>{a.timeOfDay}</strong>
                    <span>{a.activity}</span>
                    <small>{a.notes}</small>
                  </div>
                ))}
              </div>

              <div className="form-actions">
                <button type="button" className="btn-primary" onClick={addDay}>+ Add Day</button>
                <button type="submit" className="btn-primary">Save Itinerary</button>
              </div>
            </div>
          </section>
        </form>

        <aside className="preview">
          <h3>Preview Days</h3>
          <div className="preview-list">
            {daysPlan.length === 0 && <p className="muted">No days added yet.</p>}
            {daysPlan.map((d, idx) => (
              <div key={idx} className="day-card">
                <div className="day-header">
                  <h4>Day {d.dayNumber}: {d.title}</h4>
                  <div className="badge">{d.overnightStay}</div>
                </div>
                <p>{d.description}</p>
                <ul>
                  {d.activities.map((a, i) => (
                    <li key={i}>{a.timeOfDay} - {a.activity} <small>({a.notes})</small></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
}

export default AdminPanel;
